// Self-check data: profile, red-flag, modules A-H, and bilingual results
// Each option: { id, zh, en }
// Each question: { id, zh, en, type ('choice'|'slider'|'text'|'number'), options? }

export const PROFILE_QUESTIONS = [
  {
    id: 'user_role',
    zh: '你是妈妈本人，还是帮别人询问？',
    en: 'Who is filling this in?',
    type: 'choice',
    options: [
      { id: 'mother', zh: '我是妈妈本人', en: 'I am the mother' },
      { id: 'family', zh: '我是爸爸/家人', en: 'I am the father/family member' },
      { id: 'centre', zh: '我是月子中心/护理人员', en: 'I am from a confinement centre / nurse' },
      { id: 'friend', zh: '我是帮朋友询问', en: 'I am asking for a friend' },
    ],
  },
  {
    id: 'postpartum_age',
    zh: '产后多久？',
    en: 'How long has it been since delivery?',
    type: 'choice',
    options: [
      { id: '0-3d', zh: '产后 0-3 天', en: '0-3 days postpartum' },
      { id: '4-7d', zh: '产后 4-7 天', en: '4-7 days postpartum' },
      { id: '2-4w', zh: '产后 2-4 周', en: '2-4 weeks postpartum' },
      { id: '1-3m', zh: '产后 1-3 个月', en: '1-3 months postpartum' },
      { id: '3m+', zh: '产后 3 个月以上', en: 'More than 3 months postpartum' },
      { id: 'pregnant', zh: '还在怀孕中', en: 'Still pregnant' },
    ],
  },
  {
    id: 'birth_order',
    zh: '这是第几胎？',
    en: 'Which baby is this?',
    type: 'choice',
    options: [
      { id: 'first', zh: '第一胎', en: 'First baby' },
      { id: 'second', zh: '第二胎', en: 'Second baby' },
      { id: 'third+', zh: '第三胎或以上', en: 'Third baby or more' },
    ],
  },
  {
    id: 'location_type',
    zh: '你现在在哪里？',
    en: 'Where are you currently?',
    type: 'choice',
    options: [
      { id: 'centre', zh: '月子中心', en: 'Confinement centre' },
      { id: 'home', zh: '家里', en: 'Home' },
      { id: 'hospital', zh: '医院', en: 'Hospital' },
      { id: 'other', zh: '其他', en: 'Other' },
    ],
    hasText: true,
    textZh: '地区 / 月子中心名称',
    textEn: 'Area / confinement centre name',
  },
  {
    id: 'feeding_method',
    zh: '目前喂养方式？',
    en: 'Current feeding method?',
    type: 'choice',
    options: [
      { id: 'direct', zh: '亲喂', en: 'Direct breastfeeding' },
      { id: 'pump', zh: '全挤奶瓶喂', en: 'Exclusive pumping and bottle feeding' },
      { id: 'mixed', zh: '混合喂养', en: 'Mixed feeding' },
      { id: 'formula_main', zh: '配方奶为主，母乳辅助', en: 'Mainly formula with some breastmilk' },
      { id: 'not_started', zh: '还没成功开始', en: 'Not successfully started yet' },
    ],
  },
  {
    id: 'main_concern',
    zh: '你今天最想解决的问题是什么？',
    en: 'What is your main concern today?',
    type: 'choice',
    options: [
      { id: 'engorgement', zh: '乳房很胀/很硬', en: 'Breast is very full/hard' },
      { id: 'clog', zh: '怀疑堵奶/有硬块', en: 'Suspected clogged duct/lump' },
      { id: 'mastitis', zh: '发烧或乳房红肿热痛', en: 'Fever or red/hot/swollen painful breast' },
      { id: 'nipple_pain', zh: '乳头痛/破皮/出血', en: 'Nipple pain/cracked/bleeding' },
      { id: 'white_spot', zh: '乳头有白点/水泡', en: 'White spot/blister on nipple' },
      { id: 'low_supply', zh: '奶量少/奶量下降', en: 'Low milk supply/supply drop' },
      { id: 'pump_issue', zh: '挤奶器或喇叭尺寸问题', en: 'Pump or flange size issue' },
      { id: 'latch', zh: '宝宝含乳/亲喂问题', en: 'Baby latch/direct feeding problem' },
      { id: 'work_pump', zh: '回职场挤奶安排', en: 'Pumping plan for returning to work' },
      { id: 'wean', zh: '想退奶/停奶/减少奶量', en: 'I want to wean / stop breastfeeding / reduce milk supply' },
      { id: 'book', zh: '想预约上门/线上咨询', en: 'I want to book a consultation' },
    ],
  },
];

export const RED_FLAG_QUESTIONS = [
  {
    id: 'fever',
    zh: '你现在有发烧吗？',
    en: 'Do you have a fever now?',
    type: 'choice',
    options: [
      { id: 'no', zh: '没有', en: 'No' },
      { id: 'mild', zh: '有，低烧/觉得 feverish', en: 'Feverish / mild fever' },
      { id: 'high', zh: '有，体温 38°C 或以上', en: 'Yes, 38°C or above' },
      { id: 'unsure', zh: '不确定', en: 'Not sure' },
    ],
  },
  {
    id: 'chills',
    zh: '有没有发冷、全身酸痛或像感冒一样不舒服？',
    en: 'Do you have chills, body ache, or flu-like symptoms?',
    type: 'choice',
    options: [
      { id: 'no', zh: '没有', en: 'No' },
      { id: 'mild', zh: '有一点', en: 'Mild' },
      { id: 'obvious', zh: '明显有', en: 'Obvious' },
    ],
  },
  {
    id: 'redness',
    zh: '乳房皮肤有没有红、热、肿、痛？',
    en: 'Is your breast skin red, hot, swollen, or painful?',
    type: 'choice',
    options: [
      { id: 'no', zh: '没有', en: 'No' },
      { id: 'mild', zh: '有一点红/热/痛', en: 'Mild redness/heat/pain' },
      { id: 'obvious', zh: '明显红肿热痛', en: 'Obvious redness, heat, swelling, and pain' },
      { id: 'spreading', zh: '红的范围越来越大', en: 'The red area is spreading' },
    ],
  },
  {
    id: 'pain_score',
    zh: '疼痛程度 0-10 分？',
    en: 'Pain score from 0-10?',
    type: 'slider',
    min: 0,
    max: 10,
    default: 0,
  },
  {
    id: 'baby_concern',
    zh: '宝宝今天吸奶/精神/尿布是否明显异常？',
    en: "Any concern about baby's feeding, alertness, or wet diapers today?",
    type: 'choice',
    options: [
      { id: 'normal', zh: '没有明显异常', en: 'No obvious concern' },
      { id: 'fewer_diapers', zh: '尿布明显变少', en: 'Wet diapers are clearly fewer' },
      { id: 'sleepy', zh: '宝宝很嗜睡/精神差', en: 'Baby is very sleepy/weak' },
      { id: 'refuses', zh: '宝宝完全不愿意吸', en: 'Baby refuses feeds completely' },
      { id: 'unsure', zh: '不确定', en: 'Not sure' },
    ],
  },
];

// MAIN_CONCERN_TO_MODULE
export const CONCERN_MODULE_MAP = {
  engorgement: 'A',
  clog: 'B',
  mastitis: 'C',
  nipple_pain: 'D',
  white_spot: 'E',
  pump_issue: 'F',
  low_supply: 'G',
  work_pump: 'G',
  latch: 'H',
  book: null, // skip module, go straight to booking
};

// MODULES — questions and result content
export const MODULES = {
  A: {
    title_zh: '乳房很胀/很硬',
    title_en: 'Breast Fullness / Engorgement',
    questions: [
      { id: 'fullness_type', zh: '胀硬是怎样的？', en: 'What does the fullness feel like?', type: 'choice', options: [
        { id: 'both', zh: '两边乳房都整体很胀，像气球一样', en: 'Both breasts feel very full, like inflated balloons' },
        { id: 'one_side', zh: '只有一边整体胀', en: 'One breast feels generally full' },
        { id: 'local_lump', zh: '只有局部一粒/一条硬块', en: 'Local lump or hard line' },
        { id: 'areola', zh: '乳晕和乳头附近特别肿', en: 'Areola/nipple area is especially swollen' },
      ]},
      { id: 'last_removal', zh: '上一次亲喂/挤奶/手挤是多久前？', en: 'When was the last milk removal?', type: 'choice', options: [
        { id: '1-2h', zh: '1-2 小时内', en: 'Within 1-2 hours' },
        { id: '3-4h', zh: '3-4 小时', en: '3-4 hours' },
        { id: '5-6h', zh: '5-6 小时', en: '5-6 hours' },
        { id: '6h+', zh: '超过 6 小时', en: 'More than 6 hours' },
        { id: 'almost_none', zh: '今天几乎没有排奶', en: 'Almost no milk removal today' },
      ]},
      { id: 'softens_after', zh: '挤奶或亲喂后有没有变软？', en: 'Does it soften after latch/pump/hand expression?', type: 'choice', options: [
        { id: 'yes', zh: '有明显变软', en: 'Clearly softer' },
        { id: 'a_little', zh: '有一点点变软', en: 'A little softer' },
        { id: 'no', zh: '没有变软', en: 'No' },
        { id: 'cant_remove', zh: '宝宝/挤奶器吸不出来', en: 'Baby/pump cannot get milk out' },
      ]},
      { id: 'baby_latch_now', zh: '宝宝现在能不能含上？', en: 'Can baby latch when breast is full?', type: 'choice', options: [
        { id: 'yes', zh: '可以', en: 'Yes' },
        { id: 'shallow', zh: '可以但很浅/容易滑出', en: 'Yes but shallow/slips' },
        { id: 'no', zh: '含不上，因为乳晕太硬', en: 'Cannot latch because areola is too hard' },
        { id: 'not_direct', zh: '目前没有亲喂', en: 'Not directly breastfeeding' },
      ]},
    ],
    result: {
      title_zh: '你目前的情况比较像产后初期生理性涨奶',
      title_en: 'This looks more like early postpartum engorgement',
      explanation_zh: '产后前几天，乳汁开始增加，同时乳房血液和组织液也会增加，所以乳房可能会变得很胀、很硬、很痛。这个不一定是堵奶，很多妈妈会形容像气球一样硬。',
      explanation_en: 'In the first few days after delivery, milk production increases together with blood flow and tissue fluid in the breast. This can make the breasts feel very full, hard, and painful. It is not always a clogged duct.',
      steps_zh: [
        '每 2-3 小时让宝宝吸、手挤或挤奶一次',
        '如果乳晕太硬，先轻柔手挤到乳晕比较软',
        '不需要大力硬推乳房',
        '挤奶或亲喂后冷敷 10-15 分钟',
        '观察 24 小时是否越来越软、越来越舒服',
      ],
      steps_en: [
        'Remove some milk every 2-3 hours by latch, hand expression, or pumping',
        'If the areola is too hard, gently hand express until it softens',
        'Avoid aggressive deep massage',
        'Apply cold compress for 10-15 minutes after feeding or pumping',
        'Observe whether it becomes softer and more comfortable over 24 hours',
      ],
      teaching_ids: ['hand_expression', 'nipple_massage'],
    },
  },
  B: {
    title_zh: '怀疑堵奶/有硬块',
    title_en: 'Clogged Duct / Lump',
    questions: [
      { id: 'lump_type', zh: '硬块的位置和感觉？', en: 'What does the lump feel like?', type: 'choice', options: [
        { id: 'local', zh: '局部一粒硬块', en: 'Local hard lump' },
        { id: 'line', zh: '一条硬硬的', en: 'Hard line' },
        { id: 'whole_area', zh: '整片硬', en: 'Whole area hard' },
        { id: 'unsure', zh: '不确定，只是觉得里面痛', en: 'Not sure, deep pain inside' },
      ]},
      { id: 'lump_duration', zh: '硬块出现多久了？', en: 'How long has it been there?', type: 'choice', options: [
        { id: 'lt12h', zh: '少过 12 小时', en: 'Less than 12 hours' },
        { id: '12-24h', zh: '12-24 小时', en: '12-24 hours' },
        { id: '1-2d', zh: '1-2 天', en: '1-2 days' },
        { id: 'gt2d', zh: '超过 2 天', en: 'More than 2 days' },
        { id: 'recurrent', zh: '反复同一个位置', en: 'Recurrent at same spot' },
      ]},
      { id: 'supply_drop', zh: '奶量有没有突然下降？', en: 'Has milk output suddenly dropped?', type: 'choice', options: [
        { id: 'no', zh: '没有', en: 'No' },
        { id: 'slight', zh: '有，少一点', en: 'Yes, slightly' },
        { id: 'a_lot', zh: '有，少很多', en: 'Yes, a lot' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
      { id: 'missed_pump', zh: '这次之前有没有拉长挤奶/亲喂间隔？', en: 'Any missed or delayed feed/pump?', type: 'choice', options: [
        { id: 'no', zh: '没有', en: 'No' },
        { id: 'once', zh: '有，拖迟了一次', en: 'Delayed once' },
        { id: 'irregular', zh: '有，最近常常不规律', en: 'Often irregular recently' },
        { id: 'sick', zh: '生病/太累，所以少挤/少喂', en: 'Sick or too tired, fewer sessions' },
      ]},
      { id: 'milk_flow', zh: '目前还能挤出奶吗？', en: 'Can milk still flow?', type: 'choice', options: [
        { id: 'normal', zh: '可以，和平时差不多', en: 'Yes, similar as usual' },
        { id: 'less', zh: '可以，但明显少', en: 'Yes, but much less' },
        { id: 'difficult', zh: '很难出来', en: 'Difficult to get milk out' },
        { id: 'none', zh: '完全出不来', en: 'Cannot get milk out' },
      ]},
    ],
    result: {
      title_zh: '你目前比较像局部堵奶或乳汁移出不顺',
      title_en: 'This looks more like a clogged duct or local milk flow issue',
      explanation_zh: '当某个位置的乳汁排出不顺，可能会出现局部硬块、按压痛、刺痛，或那一边奶量突然变少。常见原因包括拖太久没挤、宝宝少吸、挤奶器不合、喇叭尺寸不合、压力或休息不足。',
      explanation_en: 'When milk does not move well from one area, you may feel a lump, tenderness, sharp pain, or notice reduced output on that side. Common triggers include delayed pumping/feeding, less baby sucking, pump or flange mismatch, stress, and poor rest.',
      steps_zh: [
        '继续规律亲喂或挤奶',
        '如果宝宝愿意，优先让宝宝吸不舒服那边',
        '挤奶前先轻柔刺激奶阵',
        '挤奶后冷敷 10-15 分钟',
        '不要为了通掉而过度挤到乳头受伤',
        '24 小时内观察硬块有没有变小',
      ],
      steps_en: [
        'Continue regular breastfeeding or pumping',
        'If baby is willing, start with the uncomfortable side',
        'Gently stimulate let-down before pumping',
        'Cold compress for 10-15 minutes after milk removal',
        'Do not over-pump until the nipple is injured',
        'Observe whether the lump reduces within 24 hours',
      ],
      teaching_ids: ['hand_expression', 'nipple_massage'],
    },
  },
  C: {
    title_zh: '发烧或乳房红肿热痛',
    title_en: 'Mastitis Risk',
    questions: [
      { id: 'temp', zh: '体温多少？', en: 'What is your temperature?', type: 'choice', options: [
        { id: 'unmeasured', zh: '没量体温，只是觉得热', en: 'Not measured, just feeling hot' },
        { id: '37.5-37.9', zh: '37.5-37.9°C', en: '37.5-37.9°C' },
        { id: '38.0-38.4', zh: '38.0-38.4°C', en: '38.0-38.4°C' },
        { id: '38.5+', zh: '38.5°C 或以上', en: '38.5°C or above' },
      ]},
      { id: 'fever_duration', zh: '发烧多久？', en: 'How long has fever been present?', type: 'choice', options: [
        { id: 'lt12h', zh: '少过 12 小时', en: 'Less than 12 hours' },
        { id: '12-24h', zh: '12-24 小时', en: '12-24 hours' },
        { id: 'gt24h', zh: '超过 24 小时', en: 'More than 24 hours' },
        { id: 'recurrent', zh: '反复退烧又烧', en: 'Fever goes down then returns' },
      ]},
      { id: 'red_area', zh: '乳房有没有明显红色区域？', en: 'Is there a visible red area on the breast?', type: 'choice', options: [
        { id: 'no', zh: '没有', en: 'No' },
        { id: 'mild', zh: '有一点', en: 'Mild' },
        { id: 'obvious', zh: '有明显一片', en: 'Obvious patch' },
        { id: 'spreading', zh: '红色范围扩大', en: 'Red area spreading' },
      ]},
      { id: 'doctor_seen', zh: '你是否已经看医生/正在吃药？', en: 'Have you seen a doctor or started medicine?', type: 'choice', options: [
        { id: 'no', zh: '没有', en: 'No' },
        { id: 'booked', zh: '已经预约医生', en: 'Appointment booked' },
        { id: 'seen', zh: '已经看医生', en: 'Already seen doctor' },
        { id: 'on_meds', zh: '正在吃医生开的药', en: 'Taking prescribed medicine' },
      ]},
    ],
    result: {
      title_zh: '你的情况有乳腺炎或乳房发炎风险',
      title_en: 'Your answers show possible mastitis or breast inflammation risk',
      explanation_zh: '如果出现发烧、发冷、全身酸痛、乳房红肿热痛，就不只是普通涨奶或堵奶。这个时候需要更谨慎处理，建议尽快联系医生评估，同时继续做适合的哺乳管理。',
      explanation_en: 'Fever, chills, body ache, and a red/hot/swollen painful breast may indicate inflammation or mastitis risk. Please seek medical assessment and continue appropriate breastfeeding support.',
      steps_zh: [
        '继续亲喂或挤奶以保持乳汁流动',
        '冷敷、休息、补充水分',
        '避免过度按摩或刺激',
        '如需用药，请咨询医生/药师',
      ],
      steps_en: [
        'Continue breastfeeding or pumping to keep milk moving',
        'Cold compress, rest, and hydrate',
        'Avoid aggressive massage or over-stimulation',
        'Confirm medication with doctor/pharmacist',
      ],
      doctor_warning_zh: ['体温 38°C 或以上', '发烧超过 24 小时', '红色范围扩大', '剧烈疼痛', '感觉非常不适'],
      doctor_warning_en: ['Fever 38°C or above', 'Fever over 24 hours', 'Red area spreading', 'Severe pain', 'Feeling very unwell'],
      teaching_ids: ['hand_expression', 'nipple_massage'],
      force_red: true,
    },
  },
  D: {
    title_zh: '乳头痛/破皮/出血',
    title_en: 'Nipple Pain / Cracked / Bleeding',
    questions: [
      { id: 'pain_when', zh: '疼痛发生在什么时候？', en: 'When does the pain happen?', type: 'choice', options: [
        { id: 'on_latch', zh: '宝宝一含上就痛', en: 'When baby latches' },
        { id: 'whole_feed', zh: '整个亲喂过程都痛', en: 'Throughout feeding' },
        { id: 'pumping', zh: '挤奶时痛', en: 'During pumping' },
        { id: 'after_pump', zh: '挤奶后痛', en: 'After pumping' },
        { id: 'sharp_anytime', zh: '不喂/不挤也会刺痛', en: 'Sharp pain even without feeding/pumping' },
      ]},
      { id: 'nipple_appearance', zh: '乳头外观有什么变化？', en: 'Any nipple appearance changes?', type: 'choice', options: [
        { id: 'cracked', zh: '破皮', en: 'Cracked' },
        { id: 'bleeding', zh: '出血', en: 'Bleeding' },
        { id: 'scab', zh: '结痂', en: 'Scab' },
        { id: 'white', zh: '变白', en: 'Turns white' },
        { id: 'swollen', zh: '变肿/变大', en: 'Swollen/enlarged' },
        { id: 'lipstick', zh: '像口红形状', en: 'Lipstick shape' },
        { id: 'normal', zh: '没有明显变化', en: 'No obvious change' },
      ]},
      { id: 'latch_signs', zh: '宝宝亲喂时有没有这些情况？', en: 'Any latch signs?', type: 'choice', options: [
        { id: 'narrow', zh: '宝宝嘴巴张不够大', en: 'Baby mouth not wide enough' },
        { id: 'slip', zh: '常常滑出来', en: 'Slipping off' },
        { id: 'click', zh: '有 clicking sound', en: 'Clicking sound' },
        { id: 'nipple_only', zh: '只吸乳头', en: 'Only sucking nipple' },
        { id: 'shallow', zh: '含上后会自己越吸越浅', en: 'Becomes shallow during feed' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
    ],
    result: {
      title_zh: '你的乳头疼痛可能和含乳方式或乳头创伤有关',
      title_en: 'Your nipple pain may be related to latch or nipple trauma',
      explanation_zh: '乳头疼痛常和含乳方式、姿势、挤奶器尺寸、感染或皮肤创伤有关。先调整含乳和姿势，必要时短暂使用乳头保护罩。',
      explanation_en: 'Nipple pain is often related to latch, positioning, pump size, infection, or skin trauma. Adjust latch and positioning first; use a nipple shield short-term if needed.',
      steps_zh: [
        '肚子贴肚子',
        '鼻子对乳头 / 上唇对乳头',
        '宝宝的下巴先碰到乳房',
        '疼痛太严重时短期使用 nipple shield',
        '喂完后涂抹母乳或哺乳安全乳头膏',
        '如果亲喂太痛，可手挤或轻柔挤奶以保护奶量',
      ],
      steps_en: [
        'Tummy to tummy',
        'Nose to nipple / upper lip',
        "Baby's chin touches breast first",
        'Use nipple shield short-term if pain is too much',
        'Apply breastmilk or breastfeeding-safe nipple cream after feeds',
        'If direct latch is too painful, hand express or pump gently to protect supply',
      ],
      teaching_ids: ['latch_positions', 'hand_expression'],
    },
  },
  E: {
    title_zh: '乳头有白点/水泡',
    title_en: 'White Spot / Milk Bleb',
    questions: [
      { id: 'spot_type', zh: '乳头上的点是什么样？', en: 'What does the spot look like?', type: 'choice', options: [
        { id: 'white', zh: '白色小点', en: 'White dot' },
        { id: 'clear_blister', zh: '透明水泡', en: 'Clear blister' },
        { id: 'red', zh: '红点/血点', en: 'Red/blood spot' },
        { id: 'open', zh: '破了后像伤口', en: 'Open wound after popping' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
      { id: 'lump_behind', zh: '白点后面有没有硬块或胀痛？', en: 'Any lump or pain behind it?', type: 'choice', options: [
        { id: 'no', zh: '没有', en: 'No' },
        { id: 'mild', zh: '有一点痛', en: 'Mild pain' },
        { id: 'lump', zh: '有明显硬块', en: 'Obvious lump' },
        { id: 'lump_low', zh: '有硬块而且奶量少了', en: 'Lump with reduced milk output' },
      ]},
      { id: 'trigger', zh: '最近有没有这些诱因？', en: 'Any possible trigger?', type: 'choice', options: [
        { id: 'shallow_latch', zh: '宝宝浅含乳', en: 'Shallow latch' },
        { id: 'strong_pump', zh: '泵吸力太强', en: 'Strong pump suction' },
        { id: 'flange', zh: '喇叭尺寸不合', en: 'Wrong flange size' },
        { id: 'recent_clog', zh: '最近堵奶', en: 'Recent clog' },
        { id: 'tired', zh: '最近比较少喝水/比较累', en: 'Tired/dehydrated' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
    ],
    result: {
      title_zh: '你目前可能有小白点或 milk blister',
      title_en: 'This may be a milk bleb or nipple blister',
      explanation_zh: '建议使用 Epsom salt（magnesium sulphate）。不建议用普通 rock salt 或 sea salt，因它们主要是 sodium chloride，作用不同。Epsom salt 高渗透环境有助于表面组织液移动，并可舒缓不适。若有开放性伤口、出血、剧痛或感染迹象，请先咨询专业人员。',
      explanation_en: 'Use Epsom salt (magnesium sulphate). Rock salt and sea salt are mainly sodium chloride and do not have the same purpose. Epsom salt soaking is hypertonic and may help fluid movement at the surface and soothe discomfort. If there is an open wound, active bleeding, severe pain or signs of infection, please consult a professional first.',
      steps_zh: [
        '用 Epsom salt 局部温水浸泡约 10 分钟',
        '若适合，在表面温和涂抹少量食用油',
        '继续亲喂或挤奶但减少刺激',
        '检查挤奶器吸力和喇叭尺寸',
        '观察是否出现硬块、发烧或奶量减少',
      ],
      steps_en: [
        'Gentle soaking with Epsom salt for about 10 minutes',
        'Use a touch of edible oil gently on the surface if suitable',
        'Continue breastfeeding or pumping but reduce irritation',
        'Check pump suction and flange size',
        'Watch for lump, fever, or reduced milk output',
      ],
      teaching_ids: ['epsom_salt', 'nipple_massage'],
    },
  },
  F: {
    title_zh: '挤奶器/喇叭尺寸问题',
    title_en: 'Pump / Flange Issue',
    questions: [
      { id: 'pump_type', zh: '你现在用什么类型的挤奶器？', en: 'What type of pump are you using?', type: 'choice', options: [
        { id: 'wired', zh: '手扶/有线/桌面式', en: 'Wired/desktop pump' },
        { id: 'handsfree', zh: 'hands free', en: 'Handsfree pump' },
        { id: 'hospital', zh: 'hospital grade', en: 'Hospital grade' },
        { id: 'manual', zh: '手动挤奶器', en: 'Manual pump' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
      { id: 'pump_brand', zh: '品牌/型号', en: 'Brand/model', type: 'text', placeholder_zh: '例如 Spectra S1', placeholder_en: 'e.g., Spectra S1' },
      { id: 'flange_size', zh: '当前喇叭尺寸 (左/右)', en: 'Current flange/insert size (left/right)', type: 'text', placeholder_zh: '例如 21mm / 21mm', placeholder_en: 'e.g., 21mm / 21mm' },
      { id: 'nipple_size', zh: '量到的乳头尺寸 (左/右) 或未量', en: 'Measured nipple size (L/R) or not measured', type: 'text', placeholder_zh: '例如 17mm / 18mm 或 未量', placeholder_en: 'e.g., 17mm / 18mm or not measured' },
      { id: 'pump_symptom', zh: '泵奶时发生什么？', en: 'What happens during pumping?', type: 'choice', options: [
        { id: 'pain', zh: '乳头痛', en: 'Nipple pain' },
        { id: 'white', zh: '乳头变白', en: 'Nipple turns white' },
        { id: 'swollen', zh: '乳头变肿/变大', en: 'Nipple swollen/enlarged' },
        { id: 'areola_in', zh: '乳晕被拉进去', en: 'Too much areola pulled in' },
        { id: 'sticks', zh: '乳头黏在 silicone', en: 'Nipple sticks to silicone' },
        { id: 'low_output', zh: '奶出得少', en: 'Low output' },
        { id: 'lump_after', zh: '泵完还有硬块', en: 'Hard lumps after pumping' },
        { id: 'high_suction', zh: '需要开很大力才有奶', en: 'Need high suction to get milk' },
      ]},
      { id: 'suction', zh: '吸力级数', en: 'Suction level', type: 'text', placeholder_zh: '例如 Level 5', placeholder_en: 'e.g., Level 5' },
    ],
    result: {
      title_zh: '你的问题可能和挤奶器或喇叭尺寸有关',
      title_en: 'Your issue may be related to pump or flange fit',
      explanation_zh: '不合适的喇叭尺寸或过强吸力会导致乳头痛、变白、变肿、奶量下降。建议先重新量乳头尺寸，调整 flange 和吸力。',
      explanation_en: 'Wrong flange size or excessive suction can cause nipple pain, blanching, swelling, and reduced output. Re-measure nipple size and adjust flange and suction.',
      steps_zh: [
        '先调低吸力',
        '明显造成疼痛的挤奶器先停用',
        '重新量左右乳头尺寸',
        '检查乳头是否摩擦或乳晕被过度拉入',
        '产后初期，桌面/手动辅助式可能比 handsfree 更适合一些妈妈',
        '考虑先租用再决定购买',
      ],
      steps_en: [
        'Lower suction level first',
        'Stop using a pump that clearly causes pain',
        'Re-measure left and right nipple size',
        'Check whether the nipple rubs or too much areola is pulled in',
        'Early postpartum, a desktop/manual-supported pump may work better than handsfree for some mothers',
        'Consider renting before buying',
      ],
      observation_zh: [
        '观察换喇叭尺寸或降低吸力后乳头颜色和疼痛是否改善',
        '观察 3 天奶量趋势是否回升',
        '观察乳头是否破皮、长水泡',
      ],
      observation_en: [
        'After changing flange or lowering suction, check if nipple colour / pain improves',
        'Track 3-day milk supply trend',
        'Watch for cracks or blisters on the nipple',
      ],
      when_to_seek_medical_zh: [
        '乳头持续出血、感染征兆或剧烈疼痛',
        '出现发烧、乳房红肿热痛',
      ],
      when_to_seek_medical_en: [
        'Ongoing nipple bleeding, signs of infection, or severe pain',
        'Fever, red/hot/painful breast',
      ],
      ctas: ['pump_fit'],
      teaching_ids: ['flange_fit'],
    },
  },
  G: {
    title_zh: '奶量少/奶量下降',
    title_en: 'Low Supply / Supply Drop',
    questions: [
      { id: 'supply_problem', zh: '奶量问题是什么？', en: 'What is the supply concern?', type: 'choice', options: [
        { id: 'always_low', zh: '一开始就很少', en: 'Low from the beginning' },
        { id: 'sudden_drop', zh: '最近突然变少', en: 'Suddenly dropped recently' },
        { id: 'one_side', zh: '一边明显比另一边少', en: 'One side much less' },
        { id: 'work_worry', zh: '回职场前担心不够', en: 'Worried before returning to work' },
        { id: 'baby_enough', zh: '不确定宝宝有没有喝够', en: 'Not sure if baby gets enough' },
      ]},
      { id: 'pumps_per_day', zh: '目前一天挤几次？', en: 'Pumps per day', type: 'text', placeholder_zh: '例如 6', placeholder_en: 'e.g., 6' },
      { id: 'interval', zh: '每次间隔多久？', en: 'Interval between sessions', type: 'choice', options: [
        { id: '2-3h', zh: '2-3 小时', en: '2-3 hours' },
        { id: '3-4h', zh: '3-4 小时', en: '3-4 hours' },
        { id: '4-6h', zh: '4-6 小时', en: '4-6 hours' },
        { id: 'irregular', zh: '很不规律', en: 'Very irregular' },
        { id: 'mainly_latch', zh: '主要亲喂，没有固定挤', en: 'Mainly direct latch' },
      ]},
      { id: 'milk_per_session', zh: '每次总奶量大概多少？', en: 'Approx milk per session (ml)', type: 'text', placeholder_zh: '例如 80ml', placeholder_en: 'e.g., 80ml' },
      { id: 'baby_diapers', zh: '宝宝尿布和体重如何？', en: 'Baby diapers and weight?', type: 'choice', options: [
        { id: 'normal', zh: '尿布和体重都正常', en: 'Normal' },
        { id: 'fewer', zh: '尿布偏少', en: 'Fewer diapers' },
        { id: 'poor_gain', zh: '体重增加不理想', en: 'Poor weight gain' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
      { id: 'mom_feel', zh: '妈妈现在的感觉？', en: 'How do you feel?', type: 'choice', options: [
        { id: 'okay', zh: '还可以', en: 'Okay' },
        { id: 'stressed', zh: '很压力', en: 'Stressed' },
        { id: 'tired', zh: '很累', en: 'Very tired' },
        { id: 'sad', zh: '越挤越伤心', en: 'Sad when pumping' },
        { id: 'want_stop', zh: '想放弃母乳', en: 'Thinking to stop breastfeeding' },
        { id: 'want_continue', zh: '想继续但不知道怎么做', en: 'Want to continue but don\u2019t know how' },
      ]},
    ],
    result: {
      title_zh: '你的奶量问题需要结合记录和作息一起看',
      title_en: 'Milk supply needs to be understood together with records and routine',
      explanation_zh: '一次挤奶量不能完整反映你的奶量。建议记录 3 天的真实数据，建立稳定的 3-4 小时节奏，再来评估。',
      explanation_en: 'One pumping session does not fully reflect your milk supply. Record 3 days of real data, build a steady 3-4 hour rhythm, and then evaluate.',
      steps_zh: [
        '记录 3 天的真实挤奶/亲喂模式',
        '尽量建立 3-4 小时的节奏',
        '当流量变慢时加入手挤奶',
        '不要只看一次挤奶量来判断自己',
        '混合喂养也可以是很棒的哺乳旅程',
      ],
      steps_en: [
        'Record real pumping/feeding pattern for 3 days',
        'Build a realistic 3-4 hour rhythm if possible',
        'Add hand expression when flow slows down',
        'Do not judge yourself only by one pumping amount',
        'Mixed feeding can still be a good breastfeeding journey',
      ],
      teaching_ids: ['hand_expression'],
    },
  },
  H: {
    title_zh: '宝宝含乳/亲喂问题',
    title_en: 'Latch Difficulty',
    questions: [
      { id: 'latch_main', zh: '亲喂时主要问题？', en: 'Main direct feeding issue?', type: 'choice', options: [
        { id: 'cant_latch', zh: '宝宝含不上', en: 'Baby cannot latch' },
        { id: 'painful', zh: '含上很痛', en: 'Painful latch' },
        { id: 'cries', zh: '宝宝吸一下就哭', en: 'Baby cries during feed' },
        { id: 'slips', zh: '宝宝滑出来', en: 'Slips out' },
        { id: 'click', zh: '有 clicking sound', en: 'Clicking sound' },
        { id: 'shape_change', zh: '乳头喂完变形', en: 'Nipple changes shape after feed' },
        { id: 'one_side', zh: '宝宝只愿意吸一边', en: 'Baby only takes one side' },
      ]},
      { id: 'shield', zh: '你有使用 nipple shield 吗？', en: 'Are you using nipple shield?', type: 'choice', options: [
        { id: 'no', zh: '没有', en: 'No' },
        { id: 'yes_helps', zh: '有，比较好', en: 'Yes, helps' },
        { id: 'yes_pain', zh: '有，但还是痛', en: 'Yes, still painful' },
        { id: 'yes_dislike', zh: '有，但宝宝不喜欢', en: 'Baby dislikes it' },
      ]},
      { id: 'softens_after', zh: '亲喂后乳房有没有变软？', en: 'Does breast soften after latch?', type: 'choice', options: [
        { id: 'yes', zh: '有明显变软', en: 'Clearly softer' },
        { id: 'a_little', zh: '有一点', en: 'A little' },
        { id: 'no', zh: '没有', en: 'No' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
    ],
    result: {
      title_zh: '你和宝宝可能需要调整亲喂姿势和含乳方式',
      title_en: 'You and baby may need latch and positioning support',
      explanation_zh:
        '宝宝含乳是需要学习的。如果宝宝含上会痛、容易滑出来、吸几下就哭、有 clicking sound，或喂完乳头变形，通常需要检查姿势、宝宝含乳深度、乳房状态和宝宝吸吮方式。不一定是紧急情况，但如果持续疼痛或宝宝喝不到奶，就建议预约泌乳指导。',
      explanation_en:
        'Latch is a learned skill for both mother and baby. If latch is painful, baby slips off, cries during feeding, makes clicking sounds, or the nipple changes shape after feeding, positioning and milk transfer may need support. This is not automatically an emergency, but professional latch guidance is recommended if pain continues or baby is not transferring milk well.',
      steps_zh: [
        '先回到宝宝最舒服、最熟悉的喂奶姿势',
        '让宝宝身体 tummy to tummy 面对妈妈',
        '用 nipple to nose / upper lip 引导宝宝张大嘴',
        '宝宝头微微后仰，等大嘴再把宝宝带近',
        '下巴先靠近乳房，帮助深含乳',
        '如果含乳后很痛，不要硬撑，可以重新含一次',
        '亲喂后观察乳房有没有变软、宝宝有没有吞咽',
      ],
      steps_en: [
        "Return to baby's most comfortable feeding position first",
        'Keep baby tummy to tummy with mother',
        'Use nipple to nose / upper lip to encourage a wide mouth',
        "Let baby's head tilt slightly up, then bring baby close when mouth opens wide",
        'Chin touches breast first to support a deeper latch',
        'If latch is very painful, unlatch and try again',
        'Observe whether breast softens and baby swallows during feeding',
      ],
      observation_zh: [
        '观察 24 小时内宝宝的尿布数量（一般每天 6 片以上湿尿布）',
        '观察宝宝是否有规律吞咽声、亲喂后是否满足',
        '观察乳头是否有破皮、出血或长水泡',
        '观察自己的乳房在亲喂后是否变软',
      ],
      observation_en: [
        'Track baby\u2019s wet diapers over 24 hours (usually 6+ per day)',
        'Listen for rhythmic swallowing during feeds and check if baby seems satisfied after',
        'Check the nipple for cracks, bleeding, or blisters',
        'Note whether your breast softens after feeding',
      ],
      when_to_seek_medical_zh: [
        '宝宝完全拒绝喝奶超过几餐 + 嗜睡或精神差',
        '湿尿布明显减少（24 小时少于 4 片）',
        '妈妈有发烧、乳房红肿热痛或剧烈疼痛',
        '乳头有持续流血、严重感染征兆',
      ],
      when_to_seek_medical_en: [
        'Baby refuses several feeds AND appears sleepy or weak',
        'Wet diapers drop noticeably (fewer than 4 in 24 hours)',
        'Mother has fever, red/hot/painful breast, or severe pain',
        'Nipple has ongoing bleeding or signs of infection',
      ],
      ctas: ['video_latch', 'in_person_latch'],
      teaching_ids: ['latch_positions'],
    },
  },
  I: {
    title_zh: '回职场挤奶安排',
    title_en: 'Return-to-Work Pumping Plan',
    questions: [
      { id: 'return_when', zh: '你什么时候回去上班？', en: 'When are you returning to work?', type: 'choice', options: [
        { id: 'lt1w', zh: '1 周内', en: 'Within 1 week' },
        { id: '2-4w', zh: '2-4 周内', en: 'In 2-4 weeks' },
        { id: '1-2m', zh: '1-2 个月后', en: 'In 1-2 months' },
        { id: 'already', zh: '已经回去上班', en: 'Already back at work' },
        { id: 'unsure', zh: '还不确定', en: 'Not sure yet' },
      ]},
      { id: 'feeding_method_now', zh: '你目前的喂养方式？', en: 'Current feeding method?', type: 'choice', options: [
        { id: 'direct', zh: '主要亲喂', en: 'Mainly direct breastfeeding' },
        { id: 'pump', zh: '主要挤奶瓶喂', en: 'Mainly pumping and bottle feeding' },
        { id: 'mixed', zh: '混合喂养', en: 'Mixed feeding' },
        { id: 'formula_main', zh: '配方奶为主，母乳辅助', en: 'Mainly formula with breastmilk support' },
      ]},
      { id: 'pump_freq_now', zh: '你现在多久挤一次奶？', en: 'How often do you pump now?', type: 'choice', options: [
        { id: '2-3h', zh: '2-3 小时一次', en: 'Every 2-3 hours' },
        { id: '3-4h', zh: '3-4 小时一次', en: 'Every 3-4 hours' },
        { id: '4-6h', zh: '4-6 小时一次', en: 'Every 4-6 hours' },
        { id: 'irregular', zh: '很不规律', en: 'Very irregular' },
        { id: 'rarely', zh: '很少挤奶', en: 'Rarely pump' },
      ]},
      { id: 'work_sessions', zh: '上班后你预计可以挤几次奶？', en: 'How many pumping sessions can you do at work?', type: 'choice', options: [
        { id: '1', zh: '1 次', en: 'Once' },
        { id: '2', zh: '2 次', en: 'Twice' },
        { id: '3+', zh: '3 次或以上', en: '3 or more' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
        { id: 'difficult', zh: '工作环境很难挤奶', en: 'Difficult to pump at work' },
      ]},
      { id: 'goal', zh: '你想要达成什么目标？', en: 'What is your goal?', type: 'choice', options: [
        { id: 'full', zh: '维持全母乳', en: 'Maintain full breastfeeding' },
        { id: 'mixed_ok', zh: '混合喂养也可以', en: 'Mixed feeding is okay' },
        { id: 'any', zh: '只想维持有母乳就好', en: 'Any amount of breastmilk is okay' },
        { id: 'reduce', zh: '想慢慢减少挤奶压力', en: 'Reduce pumping pressure gradually' },
      ]},
      { id: 'storage', zh: '你是否已经准备储奶？', en: 'Have you started storing milk?', type: 'choice', options: [
        { id: 'yes', zh: '已经开始', en: 'Yes' },
        { id: 'no', zh: '还没有', en: 'Not yet' },
        { id: 'unsure', zh: '不知道怎样保存', en: 'Not sure how to store milk' },
        { id: 'minimal', zh: '不打算储很多', en: 'Not planning to store much' },
      ]},
    ],
    result: {
      title_zh: '你的回职场挤奶计划需要根据工作时间慢慢调整',
      title_en: 'Your return-to-work pumping plan should be adjusted gradually',
      explanation_zh:
        '回职场不一定要一次做到完美。重点是先了解你现在的奶量、宝宝喝奶方式、工作时间和可以挤奶的次数，再慢慢拉长间隔或安排固定挤奶时间。目标可以是全母乳，也可以是混合喂养或维持有母乳给宝宝。',
      explanation_en:
        'Returning to work does not need to be perfect from day one. The key is to understand your current supply, baby\u2019s feeding pattern, work schedule, and how many pumping sessions are realistic. Your goal can be full breastfeeding, mixed feeding, or simply continuing some breastmilk.',
      steps_zh: [
        '回职场前 1-2 周开始练习固定挤奶时间',
        '如果现在 2-3 小时挤一次，可以慢慢拉到 3-4 小时一次，观察涨奶和奶量',
        '上班日尽量安排至少 1-2 次挤奶，视工作时间调整',
        '每次挤奶不用追求完全排空，以舒适和维持奶量为目标',
        '如果工作环境难挤奶，可以先规划早上、午休、下班后和睡前的挤奶安排',
        '记录 3 天奶量趋势，不要只看单次奶量',
      ],
      steps_en: [
        'Start practising a workday pumping schedule 1-2 weeks before returning to work',
        'If you currently pump every 2-3 hours, gradually stretch to 3-4 hours while observing fullness and supply',
        'Aim for at least 1-2 pumping sessions during work if possible',
        'Pumping does not need to fully empty every time; focus on comfort and maintaining supply',
        'If pumping at work is difficult, plan sessions before work, lunch break, after work, and before sleep',
        'Track a 3-day trend instead of judging by one session',
      ],
      sections_zh: [
        {
          title: '母乳储存提醒',
          items: [
            '新鲜母乳室温可短时间保存，天气热时建议尽快冷藏',
            '冷藏母乳一般建议 3-4 天内使用',
            '冷冻母乳可保存较久，建议标记日期，先进先出',
            '解冻母乳可前一晚放冷藏退冰',
            '已完全解冻的母乳建议 24 小时内使用',
            '不建议反复冷冻已经解冻的母乳',
          ],
        },
        {
          title: '挤奶器清洁与消毒',
          items: [
            '每次使用后清洗接触母乳的挤奶器配件',
            '可用温水和适合宝宝用品的清洁剂清洗',
            '彻底晾干后再收纳',
            '消毒频率可根据宝宝月龄、早产/免疫情况和使用环境调整',
            '如果宝宝早产、生病或免疫力较弱，请跟医生确认清洁消毒要求',
          ],
        },
      ],
      sections_en: [
        {
          title: 'Breastmilk Storage Reminders',
          items: [
            'Freshly expressed milk can be kept at room temperature for a short period; in hot weather, refrigerate as soon as possible',
            'Refrigerated milk is generally best used within 3-4 days',
            'Frozen milk can be stored longer; label dates and use oldest milk first',
            'Thaw frozen milk in the fridge the night before',
            'Fully thawed milk is best used within 24 hours',
            'Do not refreeze fully thawed milk',
          ],
        },
        {
          title: 'Pump Cleaning & Sterilising',
          items: [
            'Wash pump parts that touch breastmilk after each use',
            'Use warm water and baby-safe cleaning liquid',
            'Dry thoroughly before storing',
            'Sterilising frequency depends on baby\u2019s age, prematurity/health status, and environment',
            'If baby is premature, unwell, or immunocompromised, confirm cleaning requirements with doctor',
          ],
        },
      ],
      observation_zh: [
        '观察奶量趋势 3 天，不要只看单次',
        '观察自己有没有涨奶不舒服、堵奶迹象',
        '观察宝宝整体喝奶量、尿布和精神',
      ],
      observation_en: [
        'Track a 3-day milk supply trend, not just one session',
        'Watch for engorgement discomfort or clogged-duct signs',
        'Monitor baby\u2019s overall intake, diapers, and alertness',
      ],
      when_to_seek_medical_zh: [
        '如果有发烧、乳房红肿热痛或乳腺炎症状，请尽快就医',
        '如果宝宝整体喝奶量明显减少或精神变差，请咨询儿科医生',
      ],
      when_to_seek_medical_en: [
        'Seek medical care if you develop fever, red/hot/painful breast, or mastitis signs',
        'Consult a paediatrician if baby\u2019s overall intake clearly drops or baby looks unwell',
      ],
      ctas: ['work_plan', 'one_month'],
      teaching_ids: ['hand_expression', 'flange_fit'],
    },
  },
  J: {
    title_zh: '想退奶/停奶/减少奶量',
    title_en: 'Weaning / Stopping Breastfeeding / Reducing Supply',
    questions: [
      { id: 'wean_pace', zh: '你想怎样退奶？', en: 'How would you like to reduce milk?', type: 'choice', options: [
        { id: 'gradual', zh: '慢慢减少', en: 'Gradually reduce' },
        { id: 'asap', zh: '尽快停止', en: 'Stop as soon as possible' },
        { id: 'night', zh: '只想减少夜奶/夜间挤奶', en: 'Reduce night feeds or night pumping' },
        { id: 'fewer_pumps', zh: '只想减少挤奶次数', en: 'Reduce pumping sessions' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
      { id: 'feeds_per_day', zh: '目前一天亲喂/挤奶几次？', en: 'How many feeds/pumps per day now?', type: 'choice', options: [
        { id: '1-2', zh: '1-2 次', en: '1-2' },
        { id: '3-4', zh: '3-4 次', en: '3-4' },
        { id: '5-6', zh: '5-6 次', en: '5-6' },
        { id: '7+', zh: '7 次或以上', en: '7 or more' },
        { id: 'irregular', zh: '很不规律', en: 'Very irregular' },
      ]},
      { id: 'recent_issues', zh: '最近有没有堵奶、乳腺炎或发烧？', en: 'Any recent clogged ducts, mastitis, or fever?', type: 'choice', options: [
        { id: 'none', zh: '没有', en: 'None' },
        { id: 'clog', zh: '最近有堵奶', en: 'Recent clogged duct' },
        { id: 'mastitis', zh: '最近有乳腺炎/发烧', en: 'Recent mastitis / fever' },
        { id: 'recurring', zh: '反复堵奶', en: 'Recurring clogged ducts' },
        { id: 'unsure', zh: '不确定', en: 'Not sure' },
      ]},
      { id: 'current_pain', zh: '乳房现在会不会很胀或痛？', en: 'Are your breasts currently very full or painful?', type: 'choice', options: [
        { id: 'no', zh: '不会', en: 'No' },
        { id: 'mild', zh: '有一点胀', en: 'A little full' },
        { id: 'severe', zh: '很胀/痛', en: 'Very full / painful' },
        { id: 'lump', zh: '有硬块', en: 'Has a lump' },
        { id: 'red', zh: '有红肿热痛', en: 'Red, hot, painful area' },
      ]},
      { id: 'reason', zh: '为什么想退奶/停奶？', en: 'Reason for weaning?', type: 'choice', options: [
        { id: 'return_work', zh: '回职场', en: 'Returning to work' },
        { id: 'supply_stress', zh: '奶量压力', en: 'Supply pressure' },
        { id: 'breast_issues', zh: '乳房问题反复', en: 'Recurring breast issues' },
        { id: 'baby_older', zh: '宝宝已经大了', en: 'Baby is older' },
        { id: 'mother_health', zh: '妈妈身体/情绪需要', en: 'Mother\u2019s physical/emotional needs' },
        { id: 'doctor', zh: '医生建议', en: 'Doctor\u2019s advice' },
        { id: 'other', zh: '其他', en: 'Other' },
      ]},
    ],
    result: {
      title_zh: '你可以用比较温和的方式慢慢退奶/减少奶量',
      title_en: 'You can reduce milk supply gradually and gently',
      explanation_zh:
        '退奶不建议突然完全停止，尤其是目前奶量还多、容易涨奶或曾经堵奶/乳腺炎的妈妈。比较安全的方式通常是慢慢拉长亲喂或挤奶间隔、减少每次排奶量，让身体逐步降低奶量。如果需要快速退奶或使用退奶药，建议先咨询医生。',
      explanation_en:
        'It is usually not ideal to stop suddenly, especially if supply is still high or you have a history of engorgement, clogged ducts, or mastitis. A gentler approach is to gradually stretch feeding/pumping intervals and reduce the amount removed each time, allowing the body to slowly lower milk production. If you need rapid weaning or medication, please consult a doctor.',
      steps_zh: [
        '每次只减少一个亲喂/挤奶时段，不要一天内突然停很多次',
        '先拉长其中一个时段的间隔，例如从 3 小时拉到 4 小时',
        '如果很胀，可以少量挤到舒服，不要完全排空',
        '冷敷可以帮助缓解胀痛',
        '穿舒适但不过紧的内衣，避免压迫造成堵奶',
        '观察有没有硬块、红肿热痛或发烧',
        '若曾经反复堵奶或乳腺炎，建议预约顾问协助制定退奶计划',
      ],
      steps_en: [
        'Remove one feed/pump session at a time; do not stop many sessions suddenly in one day',
        'Gradually stretch one interval, for example from 3 hours to 4 hours',
        'If very full, express just enough for comfort, not to fully empty',
        'Cold compress may help reduce discomfort',
        'Wear a comfortable bra that is not overly tight',
        'Watch for lumps, redness, heat, pain, or fever',
        'If you have recurring clogged ducts or mastitis history, book a consultation for a personalised weaning plan',
      ],
      sections_zh: [
        {
          title: '食疗与中药辅助',
          items: [
            '有些妈妈会使用退奶茶、山楂麦芽煮水等食疗方式辅助减少奶量',
            '食疗效果因人而异，不应取代观察乳房状况',
            '若有慢性病、正在服药、怀孕可能性或特殊体质，请先咨询医生/中医/专业人员',
          ],
        },
        {
          title: '退奶药物提醒',
          items: [
            '如果需要快速退奶或考虑使用退奶药，请咨询医生',
            '不建议自行购买或服用退奶药',
            '用药期间仍需要观察乳房胀痛、硬块和发炎迹象',
          ],
        },
      ],
      sections_en: [
        {
          title: 'Food / Herbal Support',
          items: [
            'Some mothers use weaning tea or hawthorn/malt water as dietary support',
            'Effects vary and should not replace breast monitoring',
            'If you have medical conditions, take medication, may be pregnant, or have special health concerns, consult a doctor/TCM/professional first',
          ],
        },
        {
          title: 'Medication Reminder',
          items: [
            'If you need rapid weaning or are considering medication, consult a doctor',
            'Do not self-prescribe weaning medication',
            'Continue to monitor breast fullness, lumps, and inflammation signs',
          ],
        },
      ],
      observation_zh: [
        '观察 24-48 小时内乳房是否过度胀痛',
        '观察是否出现硬块、红肿热痛或发烧',
        '观察妈妈整体感觉是否舒适、是否出现情绪低落',
      ],
      observation_en: [
        'Watch for excessive fullness or pain over 24-48 hours',
        'Watch for lumps, redness, heat, pain, or fever',
        'Monitor your overall comfort and emotional well-being',
      ],
      when_to_seek_medical_zh: [
        '出现发烧、乳房红肿热痛或扩散',
        '硬块持续不消、范围越来越大',
        '退奶过程中出现严重情绪低落或身体不适',
      ],
      when_to_seek_medical_en: [
        'Fever, red/hot/painful breast, or area is spreading',
        'A lump that does not improve or is getting bigger',
        'Severe mood drop or physical discomfort during weaning',
      ],
      ctas: ['wean_plan', 'home_visit'],
      teaching_ids: ['hand_expression'],
    },
  },
};

export const TEACHING_CARDS = {
  hand_expression: {
    title_zh: '1 分钟手挤奶教学',
    title_en: '1-minute Hand Expression Guide',
    use_for_zh: ['涨奶', '堵奶', '小白点', '挤奶器排不干净', '亲喂前乳晕太硬'],
    use_for_en: ['Engorgement', 'Clogged duct', 'Milk bleb', "Pump not emptying well", 'Areola too hard before latch'],
    content_zh: [
      '洗手',
      '手指呈 C 形放在乳晕外侧',
      '轻轻向胸壁方向按压',
      '有节奏地按压、放松、按压',
      '不要拉乳头',
      '目标是软化乳晕，不是硬挤干',
    ],
    content_en: [
      'Wash hands',
      'C-shape fingers outside the areola',
      'Press gently toward the chest wall',
      'Compress and release rhythmically',
      'Do not pull the nipple',
      'Goal is to soften the areola, not force empty',
    ],
    video_id: 'MZAKhiriNWY',
    video_url: 'https://youtu.be/MZAKhiriNWY',
    image_url: 'https://i.ytimg.com/vi/MZAKhiriNWY/hqdefault.jpg',
  },
  nipple_massage: {
    title_zh: '乳头乳晕轻柔按摩',
    title_en: 'Gentle Nipple-Areola Massage',
    use_for_zh: ['乳头肿胀', '小白点', '乳晕乳汁堆积', '挤奶后乳头肿胀'],
    use_for_en: ['Nipple swelling', 'Milk bleb', 'Areola milk accumulation', 'Pump-related nipple swelling'],
    content_zh: [
      '指腹放在乳晕外缘',
      '轻柔地小圈按摩',
      '感受到肿胀位置时停留几秒',
      '配合慢慢手挤减压',
      '动作要轻、慢、稳',
    ],
    content_en: [
      'Place fingertips at the outer edge of the areola',
      'Make small, gentle circular motions',
      'Linger a few seconds where you feel swelling',
      'Combine with slow hand expression to relieve pressure',
      'Movements should be soft, slow, and steady',
    ],
    image_url: '',
  },
  epsom_salt: {
    title_zh: 'Epsom salt 浸泡方法',
    title_en: 'Epsom Salt Soaking Steps',
    use_for_zh: ['小白点', 'milk blister', '乳头表面不适'],
    use_for_en: ['White spot', 'Milk blister', 'Surface nipple discomfort'],
    content_zh: [
      '使用 Epsom salt（magnesium sulphate），不要用一般 rock salt / sea salt',
      '将温水（不烫）放入小杯，加入约 1-2 茶匙 Epsom salt',
      '让乳头浸泡约 10 分钟',
      '浸泡后温和擦干，可继续亲喂或挤奶',
      '若有开放伤口、剧痛或感染迹象，先咨询专业人员',
    ],
    content_en: [
      'Use Epsom salt (magnesium sulphate). Do not substitute with rock or sea salt',
      'Place warm (not hot) water in a small cup with 1-2 tsp Epsom salt',
      'Soak the nipple for about 10 minutes',
      'Pat dry and continue breastfeeding/pumping as usual',
      'If there is an open wound, severe pain, or signs of infection, consult a professional first',
    ],
    video_id: '_UWKXEoYyeI',
    video_url: 'https://youtu.be/_UWKXEoYyeI',
    image_url: 'https://i.ytimg.com/vi/_UWKXEoYyeI/hqdefault.jpg',
  },
  latch_positions: {
    title_zh: '正确含乳姿势',
    title_en: 'Latch Position Cards',
    use_for_zh: ['含乳痛', '宝宝含不深', '亲喂滑出'],
    use_for_en: ['Latch pain', 'Shallow latch', 'Slipping during feed'],
    content_zh: [
      '肚子贴肚子',
      '鼻子对乳头 / 上唇对乳头',
      '宝宝头微微仰起',
      '宝宝下巴先碰到乳房',
    ],
    content_en: [
      'Tummy to tummy',
      'Nose to nipple / upper lip to nipple',
      'Baby head tilts up slightly',
      'Baby chin touches breast first',
    ],
    video_id: 'S_UA9OHu2Zs',
    video_url: 'https://youtu.be/S_UA9OHu2Zs',
    image_url: 'https://i.ytimg.com/vi/S_UA9OHu2Zs/hqdefault.jpg',
  },
  flange_fit: {
    title_zh: 'Flange 喇叭尺寸检查',
    title_en: 'Flange Fit Check',
    use_for_zh: ['乳头痛', '乳头变白', '泵奶量少', '乳晕被拉入'],
    use_for_en: ['Nipple pain', 'Nipple blanching', 'Low pump output', 'Areola pulled in'],
    content_zh: [
      '太小：乳头摩擦喇叭壁，喂后变红/痛',
      '太大：太多乳晕被拉入，奶量低',
      '合适：乳头自由移动，乳晕几乎不进入隧道',
      '左右乳头大小可能不同，分别量测',
    ],
    content_en: [
      'Too small: nipple rubs flange wall, red/painful after pumping',
      'Too big: too much areola pulled in, low output',
      'Better fit: nipple moves freely, minimal areola in tunnel',
      'Left and right nipples may differ — measure both',
    ],
    video_id: 'taXZTSdDgtQ',
    video_url: 'https://youtu.be/taXZTSdDgtQ',
    image_url: 'https://i.ytimg.com/vi/taXZTSdDgtQ/hqdefault.jpg',
  },
};
